setTimeout(() => $(".stone-type-title").addClass("transition"), 0)

function resetStonesFilters() {
  window.centerStonesFilterState = {
    diamond: {
      type: "Loose Natural Diamond",
      shape: $(".collection-shape").html() ? $(".collection-shape").html().toLowerCase()
          .split(' ')
          .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
          .join(' ') : undefined,
      cutRange: ["cut Good", "cut Excellent"],
      colorRange: ["color J", "color D"],
      caratRange: [0.1, 10],
      caratRangeLimit: [0.1,10],
      clarityRange: ["clarity I1", "clarity FL"],
      priceRange: [300, 150000],
      polishRange: ["polish Good", "polish Excellent"],
      symmetryRange: ["symmetry Good", "symmetry Excellent"],
      labList: ["lab GIA", "lab IGI"],
      depthRange: [46, 78],
      tableRange: [52, 78],
      fluorescenceList: undefined
    },
    moissanite: {
      type: "Loose Moissanite",
      shape: undefined,
      cutRange: ["cut Excellent", "cut Excellent"],
      colorRange: ["color F", "color F"],
      caratRange: [0.1, 10],
      caratRangeLimit: [0.1,10],
      clarityRange: ["clarity VVS1", "clarity VVS1"],
      priceRange: [300, 35000],
      polishRange: ["polish Good", "polish Excellent"],
      symmetryRange: ["symmetry Good", "symmetry Excellent"],
      labList: undefined,
      depthRange: [46, 78],
      tableRange: [52, 78],
      fluorescenceList: undefined,
      filtersState: {
        shape: {
          disabled: false,
          disabled_values: ["Asscher", "Marquise"]
        },
        cutRange: {
          disabled: true
        },
        colorRange: {
          disabled: true
        },
        clarityRange: {
          disabled: true
        },
        depthRange: {
          disabled: true
        },
        tableRange: {
          disabled: true
        },
        polishRange: {
          disabled: true
        },
        symmetryRange: {
          disabled: true
        },
        labList: {
          disabled: true
        },
        fluorescenceList: {
          disabled: true
        }
      }
    },
    labDiamond: {
      type: "Loose Lab Diamond",
      shape: $(".collection-shape").html() ? $(".collection-shape").html().toLowerCase()
          .split(' ')
          .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
          .join(' ') : undefined,
      cutRange: ["cut Good", "cut Excellent"],
      colorRange: ["color J", "color D"],
      caratRange: [0.1, 10],
      caratRangeLimit: [0.1,10],
      clarityRange: ["clarity I1", "clarity FL"],
      priceRange: [300, 150000],
      polishRange: ["polish Good", "polish Excellent"],
      symmetryRange: ["symmetry Good", "symmetry Excellent"],
      labList: undefined,
      depthRange: [46, 78],
      tableRange: [52, 78],
      fluorescenceList: undefined
    }
  }
}


window.selectedStoneType = "labDiamond"
resetStonesFilters()

let numToClarityMapping = {
  1: "clarity I1",
  2: "clarity SI2",
  3: "clarity SI1",
  4: "clarity VS2",
  5: "clarity VS1",
  6: "clarity VVS2",
  7: "clarity VVS1",
  8: "clarity IF",
  9: "clarity FL"
} 
let shapeToImage = {
  "Round": "https://cdn.shopify.com/s/files/1/0769/0105/6792/files/kyzr-stone-thumb-round-front.svg?v=1689829830",
  "Oval": "https://cdn.shopify.com/s/files/1/0769/0105/6792/files/kyzr-stone-thumb-Oval-front.svg?v=1689829830",
  "Pear": "https://cdn.shopify.com/s/files/1/0769/0105/6792/files/kyzr-stone-thumb-Pear-front.svg?v=1689829830",
  "Cushion": "https://cdn.shopify.com/s/files/1/0769/0105/6792/files/kyzr-stone-thumb-cushion-front.svg?v=1689829830",
  "Princess": "https://cdn.shopify.com/s/files/1/0769/0105/6792/files/kyzr-stone-thumb-princess-front.svg?v=1689829830",
  "Marquise": "https://cdn.shopify.com/s/files/1/0769/0105/6792/files/kyzr-stone-thumb-marquise-front.svg?v=1689829830",
  "Radiant": "https://cdn.shopify.com/s/files/1/0769/0105/6792/files/kyzr-stone-thumb-radiant-front.svg?v=1689829830",
  "Asscher": "https://cdn.shopify.com/s/files/1/0769/0105/6792/files/kyzr-stone-thumb-asscher-front.svg?v=1689829830",
  "Emerald": "https://cdn.shopify.com/s/files/1/0769/0105/6792/files/kyzr-stone-thumb-emerald-front.svg?v=1689829830"
}

let numToCutMapping = {
  1: "cut Good",
  2: "cut Very Good",
  3: "cut Excellent"
}

let numToColorMapping = {
  1: "color M",
  2: "color L",
  3: "color K",
  4: "color J",
  5: "color I",
  6: "color H",
  7: "color G",
  8: "color F",
  9: "color E",
  10: "color D"
}

let numToPolishMapping = {
  1: "polish Good",
  2: "polish Very Good",
  3: "polish Excellent"
}

let numToSymmetryMapping = {
  1: "symmetry Good",
  2: "symmetry Very Good",
  3: "symmetry Excellent"
}

const params = new URLSearchParams(window.location.search)
const STONES_PER_PAGE = 70
let colorRangeList = ["color M", "color L", "color K", "color J", "color I", "color H", "color G", "color F", "color E", "color D"]
let clarityRangeList = ["clarity I1", "clarity SI2", "clarity SI1", "clarity VS2", "clarity VS1", "clarity VVS2", "clarity VVS1", "clarity IF", "clarity FL"]
let cutRangeList = ["cut Good", "cut Very Good", "cut Excellent"]
let polishRangeList = ["polish Good", "polish Very Good", "polish Excellent"]
let symmetryRangeList = ["symmetry Good", "symmetry Very Good", "symmetry Excellent"]
let latestCenterStones = []
let filterSort = 'price-ascending'


let diamondWizardFilters = {
  type: "Loose Natural Diamond",
  shape: undefined,
  cutRange: undefined,
  colorRange: undefined,
  clarityRange: undefined,
  priceRange: undefined
}

let diamondWizardPresets = {
  "best-balance": {
    colorRange: ["color H", "color D"],
    clarityRange: ["clarity VS2", "clarity FL"],
    cutRange: ["cut Very Good", "cut Excellent"],
  },
  "largest-carat": {
    colorRange: ["color J", "color D"],
    clarityRange: ["clarity SI2", "clarity FL"],
    cutRange: ["cut Good", "cut Excellent"],
  },
  "premium-quality": {
    colorRange: ["color F", "color D"],
    clarityRange: ["clarity VVS2", "clarity FL"],
    cutRange: ["cut Excellent", "cut Excellent"],
  }
}

let diamondWizardSort = 'extra-sort1-descending'

if (window.location.href.includes("center-stones") || $('[data-stones-page]')) {
  window.timeoutTimer = null
  if (!$(".collection-shape").html()) {
    if (params.get("stoneType")) {
      selectedStoneType = params.get("stoneType")
      sessionStorage.selectedStoneType = params.get("stoneType");
      window.history.replaceState(null, null, window.location.pathname);
    }

    if (params.has('shape')) {
      for (var key of params.keys()) {
        if (key != 'stoneType') {
          for (var [stone_type, value] of Object.entries(centerStonesFilterState)) {
            centerStonesFilterState[selectedStoneType][key] = params.get(key).replaceAll('-', ' ');
          }
        }
      }
      window.history.replaceState(null, null, window.location.pathname);
    } else {
      if (sessionStorage.centerStonesFilterState) {
        selectedStoneType = sessionStorage.selectedStoneType
        centerStonesFilterState = JSON.parse(sessionStorage.centerStonesFilterState)
      }

      if (sessionStorage.selected_setting_shape) {
        for (var [key, value] of Object.entries(centerStonesFilterState)) {
          centerStonesFilterState[key].shape = sessionStorage.selected_setting_shape;
        }
        sessionStorage.removeItem('selected_setting_shape');
      }
    }
  }




  setFiltersInputsValues(centerStonesFilterState[selectedStoneType])
  refreshStonesList()

  function clearTimeoutTimer() {
    if (timeoutTimer) {
      clearTimeout(timeoutTimer)
      timeoutTimer = null
    }
  }

  $(".extra-filter").toggleClass("fold", true)
  $(".filter-btn:not('#btn-load-more-mobile'), .mobile-filter-btn-close").click(function() {
    $("body").toggleClass("no-scroll")
    $(".filter-wrap").toggleClass("show")
  })

  $(".mobile-filter-btn-close").click(function() {
    $(".filter-wrap").toggleClass("show")
  })

  $("#color-slider input").on("change", function(event) {
    clearTimeoutTimer()
    timeoutTimer = setTimeout(updateTagsRangeState(event, numToColorMapping), 300)
  })

  $("#btn-load-more, #btn-load-more-mobile").on("click", (event) => {
    loadMore()
  })

  $("#cut-slider input").on("change", function(event) {
    clearTimeoutTimer()
    timeoutTimer = setTimeout(updateTagsRangeState(event, numToCutMapping), 300)
  })

  $("#clarity-slider input").on("change", function(event) {
    clearTimeoutTimer()
    timeoutTimer = setTimeout(updateTagsRangeState(event, numToClarityMapping), 300)
  })

  $("#polish-slider input").on("change", function(event) {
    clearTimeoutTimer()
    timeoutTimer = setTimeout(updateTagsRangeState(event, numToPolishMapping), 300)
  })

  $("#symmetry-slider input").on("change", function(event) {
    clearTimeoutTimer()
    timeoutTimer = setTimeout(updateTagsRangeState(event, numToSymmetryMapping), 300)
  })

  $("#price-slider input, #carat-slider input, #depth-slider input, #table-slider input").on("change", function(event) {
    clearTimeoutTimer()
    timeoutTimer = setTimeout(updateNumberRangeState(event), 300)
  })

  $("[name=\"stone-type\"]").on("change", function(event) {
    selectedStoneType = $(this).val()
    setFiltersInputsValues(centerStonesFilterState[selectedStoneType])
    refreshStonesList()
  })

  $("[name='lab']").on("change", function(event) {
    selected = []
    $("input[name=\"lab\"]:checked").each(function() {
      selected.push("lab " + $(this).attr("value"))
    })
    centerStonesFilterState[selectedStoneType].labList = selected;
    refreshStonesList()
  });

  $("#stone-shapes-filter").click((event) => {
    let currentTarget = event.target
    let targetValue = currentTarget.getAttribute("value")
    let currentTargetName = currentTarget.getAttribute("name")

    if (currentTargetName === "shape") {
      centerStonesFilterState[selectedStoneType].shape = targetValue
      $("*[data-filter-btn=\"Shape\"]").addClass("filtered")
      $("*[data-filter-btn=\"Shape\"]").attr("data-filter-filtered", targetValue)
      refreshStonesList()
    }
  })

  $(".filter.dropdown-wrap").click((event) => {
    let currentTarget = event.target
    let currentTargetName = currentTarget.getAttribute("name")
    var selected = undefined

    if (currentTargetName === "fluorescence") {
      selected = []
      $("input[name=\"fluorescence\"]:checked").each(function() {
        selected.push("fluorescence " + $(this).attr("value"))
      })
      centerStonesFilterState[selectedStoneType].fluorescenceList = selected
      $("[data-fluorescence-list-filter]").attr("data-selected", selected.length)
    }

    if (selected) {
      if (selected.length) {
        event.target.parentNode.parentNode.classList.add("selected")
      } else {
        event.target.parentNode.parentNode.classList.remove("selected")
      }
      refreshStonesList()
    }
  })

  function updateNumberRangeState(event) {
    if (event.target.type === "range") {
      if (event.target.parentElement.parentElement.parentElement.id === "price-slider") {
        if (event.target.dataset.rangeType === "min") {
          centerStonesFilterState[selectedStoneType].priceRange[0] = event.target.value
        } else if (event.target.dataset.rangeType === "max") {
          centerStonesFilterState[selectedStoneType].priceRange[1] = event.target.value
        }
      } else if (event.target.parentElement.parentElement.parentElement.id === "carat-slider") {
        if (event.target.dataset.rangeType === "min") {
          centerStonesFilterState[selectedStoneType].caratRange[0] = Number(event.target.value) / 100
        } else if (event.target.dataset.rangeType === "max") {
          centerStonesFilterState[selectedStoneType].caratRange[1] = Number(event.target.value) / 100
        }
      } else if (event.target.parentElement.parentElement.parentElement.id === "depth-slider") {
        if (event.target.dataset.rangeType === "min") {
          centerStonesFilterState[selectedStoneType].depthRange[0] = Number(event.target.value)
        } else if (event.target.dataset.rangeType === "max") {
          centerStonesFilterState[selectedStoneType].depthRange[1] = Number(event.target.value)
        }
      } else if (event.target.parentElement.parentElement.parentElement.id === "table-slider") {
        if (event.target.dataset.rangeType === "min") {
          centerStonesFilterState[selectedStoneType].tableRange[0] = Number(event.target.value)
        } else if (event.target.dataset.rangeType === "max") {
          centerStonesFilterState[selectedStoneType].tableRange[1] = Number(event.target.value)
        }
      }

      refreshStonesList()
    }
  }

  function updateTagsRangeState(event, rangeMapping) {
    if (event.target.type === "range" && centerStonesFilterState[selectedStoneType].type != "Loose Moissanite") {
      if (event.target.parentElement.parentElement.parentElement.id === "color-slider") {
        if (event.target.dataset.rangeType === "min") {
          centerStonesFilterState[selectedStoneType].colorRange[0] = rangeMapping[event.target.value]
        } else if (event.target.dataset.rangeType === "max") {
          centerStonesFilterState[selectedStoneType].colorRange[1] = rangeMapping[event.target.value - 1]
        }
      } else if (event.target.parentElement.parentElement.parentElement.id === "clarity-slider") {
        if (event.target.dataset.rangeType === "min") {
          centerStonesFilterState[selectedStoneType].clarityRange[0] = rangeMapping[event.target.value]
        } else if (event.target.dataset.rangeType === "max") {
          centerStonesFilterState[selectedStoneType].clarityRange[1] = rangeMapping[event.target.value - 1]
        }
      } else if (event.target.parentElement.parentElement.parentElement.id === "cut-slider") {
        if (event.target.dataset.rangeType === "min") {
          centerStonesFilterState[selectedStoneType].cutRange[0] = rangeMapping[event.target.value]
        } else if (event.target.dataset.rangeType === "max") {
          centerStonesFilterState[selectedStoneType].cutRange[1] = rangeMapping[event.target.value - 1]
        }
      }else if (event.target.parentElement.parentElement.parentElement.id === "polish-slider") {
        if (event.target.dataset.rangeType === "min") {
          centerStonesFilterState[selectedStoneType].polishRange[0] = rangeMapping[event.target.value]
        } else if (event.target.dataset.rangeType === "max") {
          centerStonesFilterState[selectedStoneType].polishRange[1] = rangeMapping[event.target.value - 1]
        }
      } else if (event.target.parentElement.parentElement.parentElement.id === "symmetry-slider") {
        if (event.target.dataset.rangeType === "min") {
          centerStonesFilterState[selectedStoneType].symmetryRange[0] = rangeMapping[event.target.value]
        } else if (event.target.dataset.rangeType === "max") {
          centerStonesFilterState[selectedStoneType].symmetryRange[1] = rangeMapping[event.target.value - 1]
        }
      }

      refreshStonesList()
    }
  }

  function refreshStonesList() {
    sessionStorage.centerStonesFilterState = JSON.stringify(centerStonesFilterState)
    sessionStorage.selectedStoneType = selectedStoneType
    let filterQuery = generateFilterQuery()
    let urlFinal = `https://services.mybcapps.com/bc-sf-filter/filter?pf_st_stock_status[]=true&sort=${filterSort}&shop=kev-jewellery.myshopify.com&limit=${STONES_PER_PAGE}${filterQuery}`

    fetch(urlFinal, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    }).then((res) => {
      res.text().then((resText) => {
        $("[data-collection-container]").empty()
        let resObj = JSON.parse(resText)
        console.log(resObj)
        latestCenterStones = resObj.products
        showCenterStones(resObj)
        $("[data-filter-results]").attr("data-filter-results", resObj.total_product);
        $('[data-current-products-count]').html(latestCenterStones.length);
        $('[data-results-count]').html(resObj.total_product);
      })
    })
  }

  function loadMore() {
    let page = latestCenterStones.length / STONES_PER_PAGE + 1
    let filterQuery = generateFilterQuery()
    let urlFinal = `https://services.mybcapps.com/bc-sf-filter/filter?pf_st_stock_status[]=true&sort=${filterSort}&shop=kev-jewellery.myshopify.com&limit=${STONES_PER_PAGE}&page=${page}${filterQuery}`

    fetch(urlFinal, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    }).then((res) => {
      res.text().then((resText) => {
        let resObj = JSON.parse(resText);
        latestCenterStones = latestCenterStones.concat(resObj.products);
        $('[data-current-products-count]').html(latestCenterStones.length);
        showCenterStones(resObj);
      })
    })
  }

  function showCenterStones(result) {
    var productsList = result.products;

    if (latestCenterStones.length == result.total_product) {
      $("#btn-load-more, #btn-load-more-mobile").hide()
    } else {
      $("#btn-load-more, #btn-load-more-mobile").show()
    }

    productsList.forEach((product, index) => {
      let productElement = createCenterStoneProductElement(product, latestCenterStones.length - STONES_PER_PAGE + index);
    })
    processLoadingBtns()

    $("img.center-stone-image").one("load", (event) => {
      $($($(event.target).parent()).parent()).removeClass("pre-loader")
    })

    if($('[data-collection-container]').is(':empty')) {
      $('[data-collection-no-results]').fadeIn();
    } else {
      $('[data-collection-no-results]').fadeOut();
    }
  }

  function toggleClass(element, className) {
    element.classList.contains(className) ? element.classList.remove(className) : element.classList.add(className)
  }

  function openCenterStoneThumb(element) {
    if(window.matchMedia('(max-width: 600px)').matches) {
      if (event) {
        event.preventDefault()
        event.stopPropagation()
      }

      const calcMargin = () => {
        const stoneItemsArray = [...$(".center-stone-item")]
        const opened = $(".center-stone-item.opened")[0]
        const openedIsPrev = opened && stoneItemsArray.indexOf(element) > stoneItemsArray.indexOf(opened)
        const margin = openedIsPrev ? $(opened).height() - 220 : 0

        return margin
      }

      const toOpen = !element.classList.contains("opened")
      const stoneId = element.dataset.stoneId

      // const margin = calcMargin()
      const margin = 0

      $(".center-stone-item").removeClass("opened opened-360").attr("onclick", `openCenterStoneThumb(this)`).children(".bottom-section").slideUp(0) && $(".center-stone-item").find(".center-stone-item-img-wrap").unbind("click").children("div").siblings("iframe").remove()
      $(".center-stone-item-img-wrap").removeAttr("style")

      toOpen && $(element).addClass("opened").attr("onclick", "").children(".bottom-section").slideDown(0) && $(element).find(".center-stone-item-img-wrap").click(function() {
        $(element).addClass("opened-360")
        const iframe = element.dataset.vendor.includes("nivoda") ? `<iframe style="background:#9B9B9B;border:none;width: 100%;position: absolute;height: 100%;z-index: 9;top: 0;left: 0;" scrolling="no" class="stoneVideo" src="https://loupe360.com/diamond/${(stoneId + "").toUpperCase()}/video/rsp/autoplay"</iframe>`
            : `<iframe style="background:#9B9B9B;border:none;width: 100%;position: absolute;height: 100%;z-index: 9;top: 0;left: 0;" scrolling="no" class="stoneVideo" src="https://kcsvs.keyzarjewelry.com/static/Vision360.html?d=${(stoneId + "").toUpperCase()}&surl=https://kcsvs.keyzarjewelry.com/"</iframe>`
        this.innerHTML = element.dataset.vidLink.includes("vimeo") ? this.innerHTML : this.innerHTML + iframe
      }).click() && scrollToElement(element, margin);

      if (element.dataset.vendor.includes("nivoda")) {
        $(".center-stone-item.opened .center-stone-item-slide-wrap .center-stone-item-img-wrap").height($(".center-stone-item.opened .center-stone-item-slide-wrap .center-stone-item-img-wrap").width())
      }

      if($('.center-stone-item.opened').length) {
        $('body').addClass('center-stone-item-opened');
      } else {
        $('body').removeClass('center-stone-item-opened');
      }

      if(!element.querySelector('klarna-placement')) {
        element.querySelector('.cmsi-item-klarna-message-text').innerHTML = `
          <klarna-placement
              data-key="credit-promotion-auto-size"
              data-locale="en-US"
              data-purchase-amount="${element.dataset.productPriceMin}"
            ></klarna-placement>
        `;
        window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
        window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
      }
    }

  }

  $(document).on('mouseenter', '.center-stone-item', function(event) {
    if(event.target.classList.contains('center-stone-item')) {
      element = event.target;
    } else {
      element = $(event.target).parents('.center-stone-item')[0];
    }
    if(!element.querySelector('klarna-placement')) {
      element.querySelector('.cmsi-item-klarna-message-text').innerHTML = `
        <klarna-placement
            data-key="credit-promotion-auto-size"
            data-locale="en-US"
            data-purchase-amount="${element.dataset.productPriceMin}"
          ></klarna-placement>
      `;
      window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    }
  });

  $(document).on('mouseleave', '.center-stone-item', function(event) {
    if(event.target.classList.contains('center-stone-item')) {
      element = event.target;
    } else {
      element = $(event.target).parents('.center-stone-item')[0];
    }

    if(element.querySelector('klarna-placement')) {
      element.querySelector('klarna-placement').remove();
    }
  });

  function scrollToElement(element, margin) {
    if (!window.matchMedia("(min-width: 601px)").matches) {
      $([document.documentElement, document.body]).animate({
        scrollTop: element.getBoundingClientRect().top - document.body.getBoundingClientRect().top - margin - 62
      }, 0)
    }
  }

  function showCert(evt, element) {
    evt.preventDefault()
    evt.stopPropagation()

    let iframeOverlay = document.getElementById("iframe-overlay")

    if (!iframeOverlay) {
      iframeOverlay = document.createElement("div")
      iframeOverlay.id = "iframe-overlay"
      iframeOverlay.style.display = "none"
      document.body.appendChild(iframeOverlay)
    }

    iframeOverlay.innerHTML = `<iframe src="${element.href}"></iframe>`

    $(iframeOverlay).fadeIn()
  }


  function closeCert() {
    $("#iframe-overlay").fadeOut()
  }

  function createCenterStoneProductElement(product, index) {
    const productsContainer = $("[data-collection-container]")
    const stoneInfo = {}
    const thumbnailOnclickFunction = window.selectedStoneType == "moissanite" ? "loadMoissaiteIframe(this)" : "loadDiamondIframe(this)"
    const splitHandle = product.handle.split("-")
    const stone_id = splitHandle[splitHandle.length - 1]

    for (let k = 0; k < product.tags.length; k++) {
      const splitTag = product.tags[k].split(/ (.+)/)
      stoneInfo[splitTag[0]] = splitTag[1] === "true" ? true : splitTag[1] === "false" ? false : splitTag[1]
    }

    const hasImage = !!product.images[1]
    const has360 = stoneInfo.hasOwnProperty("vidLink") && stoneInfo.vidLink
    
   // if (!has360) return null

    const compareAtPriceDiv = product.compare_at_price_min > product.price_min ? `<div class="price before-discount">\$${Math.round(product.compare_at_price_min).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>` : ""
    let html = ""

    let itemThumbClass = "item-thumb pre-loader"
    itemThumbClass = itemThumbClass + (!hasImage ? " no-image" : "")
    itemThumbClass = itemThumbClass + (has360 ? " video-360" : "")

    const imgSrc = hasImage ? product.images[1] : shapeToImage[stoneInfo.shape]

    const certObj = product.metafields.find(meta => meta.key === "cert-link")

    const makeInfo = (property, value) => `
    <div class="center-stone-item-info-element" data-info-key="${property}">
      <span class="center-stone-item-info-element-property">${property.capitalize()}</span>
      <span class="center-stone-item-info-element-value">${value}</span>
    </div>
    `

    const makeCert = (certObjOld, lab) => {
      const certObjNew = {
        certPageLink: certObjOld.value,
        certId: "",
        certLink: "",
        img: ""
      }

      certObjNew.certId = certObjNew.certPageLink.split("=").reverse()[0]

      if (lab.toLowerCase() === "igi") {
        certObjNew.img = "https://www.igi.org/assets/images/logo-for-title.svg"
        certObjNew.certLink = "https://www.igi.org/viewpdf.php?r=" + certObjNew.certId
      } else if (lab.toLowerCase() === "gia") {
        certObjNew.img = "https://cdn.shopify.com/s/files/1/0039/6994/1568/t/116/assets/kzr-icon-gia-crt.svg?v=1638199804"
        certObjNew.certLink = certObjNew.certPageLink
      }

      return certObjNew
    }

    const makeCenterStoneObj = () => {
      const centerStoneObj = {
        product_id: product.id,
        handle: product.handle,
        product_title: product.title,
        image_url: imgSrc,
        price: product.price_min,
        compare_at_price: product.compare_at_price_min,
        sku: product.skus[0],
        shape: stoneInfo.shape,
        carat: stoneInfo.carat,
        color: stoneInfo.color,
        cut: stoneInfo.cut,
        polish: stoneInfo.polish,
        symmetry: stoneInfo.symmetry,
        fluorescence: stoneInfo.fluorescence,
        length_to_width: "0.35",
        length_to_width_ratio: "0.35",
        certificate: stoneInfo.lab,
        certificate_url: cert?.certPageLink || ""
      }

      return JSON.stringify(centerStoneObj);
    }


    const cert = !certObj || !stoneInfo.lab ? null : makeCert(certObj, stoneInfo.lab)

    // For overlay add to the <a> tag `onclick="showCert(event, this)"`
    const certDiv = cert ? 
    `<div class="center-stone-item-certificate-link-wrapper hidden-desktop">
        <a class="center-stone-item-certificate-link" target="_blank" href="${cert.certLink}">
        
          <span class="center-stone-item-certificate-type">${product.title.includes('Treated') ? "Treated " + product.product_type.replaceAll('Loose', '') : product.product_type.replaceAll('Loose', '')}</span>
          <img width="72" height="72" src="${cert.img}" alt="${stoneInfo.lab.toUpperCase()} Certificate">
          <span class="center-stone-item-view-certificate">View Certificate</span>
        </a>
      </div>` : ""

    var compare_at_price = '';
    if (product.compare_at_price_min > product.price_min) {
      compare_at_price = `
        <div class="price price-compare">\$${Math.round(product.compare_at_price_min).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
      `;
    }

    var button_text = 'Complete Your Ring';
  /*  if (configurationData?.configuration?.setting) {
      configurationType == 'Pendant' ? button_text = 'Complete Your Pendant' : button_text = 'Complete Your Ring'
    } else {
      configurationType == 'Pendant' ? button_text = 'Add Pendant' : button_text = 'Add Setting'
    }

    configurationData?.configuration?.setting == undefined ? "Select This Diamond" : configurationType == 'Pendant' ? "Complete Your Pendant" : "Complete Your Ring"
*/
    infoKeysArray = ["carat", "shape", "color", "clarity", "lab", "cut"];
    if(stoneInfo.shape != 'Round') {
      infoKeysArray = infoKeysArray.filter(e => e !== 'cut'); 
    }

    html = `
      <div class="center-stone-item card-shadow" data-vendor="${product.vendor}" data-vid-link="${stoneInfo.vidLink}" data-stone-id="${stone_id}" onclick="openCenterStoneThumb(this)" style="order: ${index}; --aspect_ratio: ${product.metafields.find(meta => meta.key === "video-ratio") ? product.metafields.find(meta => meta.key === "video-ratio").value : 1.25 };" data-product-price-min="${product.price_min * 100}" data-product-item>
        <div class="center-stone-item-top-controls">
          <button class="center-stone-item-controls-button" disabled style="visibility: hidden;">
            <svg class="cmsi-switch-icon" aria-hidden="true" focusable="false"> <use xlink:href="#sirv-360-icon"></use></svg>
          </button>
          <button class="center-stone-item-controls-button" onclick="openCenterStoneThumb(this.closest('.center-stone-item'))">
            <svg class="cmsi-close-icon" aria-hidden="true" focusable="false"> <use xlink:href="#close-icon"></use></svg>
          </button>
        </div>
        <div class="center-stone-item-slide-wrap">
          <div class="center-stone-item-img-wrap diamWrap">
            <div>
              <img class="diamImage" 
                src="${imgSrc}"
                alt="${hasImage ? imageAltWithoutData(product.images_info[0].alt) : product.title}"
                ${hasImage ? imageAltDataAttributes(product.images_info[0].alt) : ''}>
            </div>

            <a href="${location.pathname + '/products/' + product.handle}" class="cmsi-item-link" data-handle="${product.handle}"></a>
          </div>
          <div class="center-stone-item-info">
            <div>${infoKeysArray.reduce((result, key) => result + makeInfo(key, stoneInfo[key]), "")}</div>
            <div class="price-wrap">
              ${compare_at_price}
              <div class="price price-final">\$${Math.round(product.price_min).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
            </div>
          </div>
        </div>
        <div class="bottom-section">
          <div style="display: flex; justify-content: space-between; align-items: flex-start;">
            <div>
              <div class="title hidden-mobile">${stoneInfo.shape}</div>
              <div class="title hidden-desktop"><span class="center-stone-item-carat-value">${stoneInfo.carat}</span><span class="center-stone-item-carat-suffix">ct</span> ${stoneInfo.shape}</div>
            </div>
            <div class="price-wrap">
              ${compare_at_price}
              <div class="price price-final">\$${Math.round(product.price_min).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
            </div>
          </div>
          
          <div class="cmsi-item-info-outer-wrapper">
            <div class="cmsi-item-info-wrapper">
              ${infoKeysArray.reduce((result, key) => result + makeInfo(key, stoneInfo[key]), "")}
            </div>
            ${certDiv}
          </div>
          <div class="cmsi-item-buttons-container">
            <a href="/products/${product.handle}" class="cmsi-item-secondary-button" data-handle="${product.handle}">More Info</a> 
          </div>
          <div class="cmsi-item-klarna-message">
            <span class="cmsi-item-klarna-message-text">
            
            </span>
          </div>
        </div>
        <script type="application/json" data-product-json>
          ${makeCenterStoneObj()}
        </script>
      </div>
    `


    productsContainer.append(html);
    console.log(html)

    if(!index) {
      productsContainer.append(`
        <button type="button" data-toggle-diamond-wizard-popup class="custom-diamond-wizard-toggler">
          <div class="custom-diamond-wizard-toggler-top-container">
            <div class="custom-diamond-wizard-toggler-logo-container">
              <div class="custom-diamond-wizard-toggler-logo-wrapper custom-image-wrapper" style="--aspect_ratio: 1;">
                <img class="custom-image lazyload" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" data-src="${theme.diamondWizard.logo}">
              </div>
            </div>
            <h3 class="custom-diamond-wizard-toggler-title">${theme.diamondWizard.title}</h3>
          </div>
          <div class="custom-diamond-wizard-toggler-bottom-container">
            <div class="custom-diamond-wizard-cta">
              <div class="custom-diamond-wizard-cta-text">${theme.diamondWizard.cta}</div>
              <div class="custom-diamond-wizard-cta-arrow">
                <svg class="svg-icon">
                  <use xlink:href="#arrow-right" />
                </svg>
              </div>
            </div>
          </div>
        </button>
      `);
    }
  }

  function loadMoissaiteIframe(itemThumb) {
    return
    if ($(itemThumb).attr("data-vid-link")) {
      $(itemThumb).empty()
      $(itemThumb).append(
        `<div style="padding:100% 0 0 0;position:relative;">
<iframe src="${$(itemThumb).attr("data-vid-link")}?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="z-index:2;position:absolute;top:0;left:0;width:100%;height:100%;"></iframe>
       </div>
       <script src="https://player.vimeo.com/api/player.js"></script>`
      )
    }
    console.log("mois")
    console.log($(itemThumb).attr("data-vid-link"))
  }

  function loadDiamondIframe(itemThumb) {
    if ($(itemThumb).attr("data-vid-link").includes("true")) {
      $(itemThumb).empty()
      $(itemThumb).append(`<iframe style="z-index:2;position:absolute;top:0;left:0;height:120%;" scrolling="no" class="stoneVideo" src="https://kcsvs.keyzarjewelry.com/static/Vision360.html?d=${$(itemThumb).attr("data-stone-id").toUpperCase()}&surl=https://kcsvs.keyzarjewelry.com/"</iframe>`)
    } else if ($(itemThumb).attr("data-vid-link").includes("vimeo")) {
      console.log($(itemThumb).attr("data-vid-link"))
      console.log(`<iframe style="z-index:2;position:absolute;top:0;left:0;width:100%;height:100%;" scrolling="no" class="stoneVideo" src="${$(itemThumb).attr("data-vid-link")}"</iframe>`)
      $(itemThumb).empty()
      $(itemThumb).append(
        `<div style="padding:100% 0 0 0;position:relative;">
<iframe src="${$(itemThumb).attr("data-vid-link")}?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="z-index:2;position:absolute;top:0;left:0;width:100%;height:100%;"></iframe>
       </div>
       <script src="https://player.vimeo.com/api/player.js"></script>`)
    }
  }

  function removeElement(el) {
    $(el).remove()
  }

  function generateFilterQuery() {
    let retQuery = ""

    if (centerStonesFilterState[selectedStoneType].type) {
      retQuery += `&product_type=${centerStonesFilterState[selectedStoneType].type}`

    }
    if (centerStonesFilterState[selectedStoneType].shape) {
      retQuery += `&pf_t_shape[]=shape ${centerStonesFilterState[selectedStoneType].shape}`

    }
    if (centerStonesFilterState[selectedStoneType].priceRange) {
      let priceFilterQuery = generateNumbersRangeQuery("pf_p_price", centerStonesFilterState[selectedStoneType].priceRange[0], centerStonesFilterState[selectedStoneType].priceRange[1])
      retQuery += priceFilterQuery

    }
    if (centerStonesFilterState[selectedStoneType].caratRange) {
      let caratFilterQuery = generateNumbersRangeQuery("pf_rs1_carat", centerStonesFilterState[selectedStoneType].caratRange[0], centerStonesFilterState[selectedStoneType].caratRange[1])
      retQuery += caratFilterQuery

    }

    if (selectedStoneType != "moissanite") {
      if (centerStonesFilterState[selectedStoneType].cutRange) {
        let cutsToFilter = getAllInTagsRange(centerStonesFilterState[selectedStoneType].cutRange, cutRangeList)
        let cutsFilterQuery = generateTagsRangeQuery("pf_t_cut", cutsToFilter)
        retQuery += cutsFilterQuery
        if (retQuery.includes("&pf_t_cut[]=cut Excellent")) retQuery += "&pf_t_cut[]=cut Ideal"

      }
      if (centerStonesFilterState[selectedStoneType].colorRange) {
        let colorsToFilter = getAllInTagsRange(centerStonesFilterState[selectedStoneType].colorRange, colorRangeList)
        let colorsFilterQuery = generateTagsRangeQuery("pf_t_color", colorsToFilter)
        retQuery += colorsFilterQuery

      }
      if (centerStonesFilterState[selectedStoneType].clarityRange) {
        let clarityToFilter = getAllInTagsRange(centerStonesFilterState[selectedStoneType].clarityRange, clarityRangeList)
        let clarityFilterQuery = generateTagsRangeQuery("pf_t_clarity", clarityToFilter)
        retQuery += clarityFilterQuery

      }
      if (centerStonesFilterState[selectedStoneType].polishRange) {
        let polishToFilter = getAllInTagsRange(centerStonesFilterState[selectedStoneType].polishRange, polishRangeList)
        let polishFilterQuery = generateTagsRangeQuery("pf_t_polish", polishToFilter)
        retQuery += polishFilterQuery

      }
      if (centerStonesFilterState[selectedStoneType].symmetryRange) {
        let symmetryToFilter = getAllInTagsRange(centerStonesFilterState[selectedStoneType].symmetryRange, symmetryRangeList)
        let symmetryFilterQuery = generateTagsRangeQuery("pf_t_symmetry", symmetryToFilter)
        retQuery += symmetryFilterQuery

      }
      if (centerStonesFilterState[selectedStoneType].labList && centerStonesFilterState[selectedStoneType].labList.length) {
        let labFilterQuery = generateTagsRangeQuery("pf_t_lab", centerStonesFilterState[selectedStoneType].labList)
        retQuery += labFilterQuery

      }
      if (centerStonesFilterState[selectedStoneType].depthRange) {
        let depthFilterQuery = generateNumbersRangeQuery("pf_rs2_depth", centerStonesFilterState[selectedStoneType].depthRange[0], centerStonesFilterState[selectedStoneType].depthRange[1])
       // retQuery += depthFilterQuery

      }
      if (centerStonesFilterState[selectedStoneType].tableRange) {
        let tableFilterQuery = generateNumbersRangeQuery("pf_rs3_table", centerStonesFilterState[selectedStoneType].tableRange[0], centerStonesFilterState[selectedStoneType].tableRange[1])
     //   retQuery += tableFilterQuery

      }
      if (centerStonesFilterState[selectedStoneType].fluorescenceList && centerStonesFilterState[selectedStoneType].fluorescenceList.length) {
        let fluorescenceFilterQuery = generateTagsRangeQuery("pf_t_fluorescence", centerStonesFilterState[selectedStoneType].fluorescenceList)
        retQuery += fluorescenceFilterQuery
      }
    }

    return retQuery
  }

  function getAllInTagsRange(range, rangeList) {
    let rangeMin = range[0]
    let rangeMax = range[1]
    let retList = []
    let i = 0
    let inRange = false

    for (i; i < rangeList.length; i++) {
      if (rangeList[i] == rangeMin) {
        inRange = true
      }

      if (inRange) {
        retList.push(rangeList[i])
      }

      if (rangeList[i] == rangeMax) {
        inRange = false
      }
    }

    return retList
  }

  function generateTagsRangeQuery(queryPrefix, rangeList) {
    let retQuery = ""

    rangeList.forEach((value) => retQuery += "&" + queryPrefix + "[]=" + value)

    return retQuery
  }

  function generateNumbersRangeQuery(queryPrefix, min, max) {
    return `&${queryPrefix}[]=${min}:${max}`
  }

  function getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value)
  }

  function setFiltersInputsValues(state) {
    $('[data-filter-name]').removeClass('selected');
    $('[data-filter-current-value]').html('');
    for (var [key, value] of Object.entries(state)) {
      $(`[data-filter-name="${key}"][data-filter-value="${value}"]`).addClass('selected');
      var selected_display_value = $(`[data-filter-name="${key}"][data-filter-value="${value}"]`).data('filter-display-value');
      $(`[data-filter-current-value][data-filter-key="${key}"]`).html(selected_display_value);
    }

    $("[name=\"stone-type\"]").prop("checked", false)
    $(`[name="stone-type"][value="${selectedStoneType}"]`).prop("checked", true)

    // Shape filter
    if (state.shape) {
      $('[data-filter-name="shape"]').removeClass('selected');
      $(`[data-filter-name="shape"][data-filter-value="${state.shape}"]`).addClass('selected');
    } else {
      $('[data-filter-name="shape"]').removeClass('selected');
    }

    // Cut filter
    if (state.cutRange) {
      cut_slider = $("#cut-slider")
      cut_range_min_value = parseInt(getKeyByValue(numToCutMapping, state.cutRange[0]))
      cut_range_max_value = parseInt(getKeyByValue(numToCutMapping, state.cutRange[1])) + 1
      cut_slider.find("[data-range-type=\"min\"]").val(cut_range_min_value).trigger("input")
      cut_slider.find("[data-range-type=\"max\"]").val(cut_range_max_value).trigger("input")
    }

    // Color filter
    if (state.colorRange) {
      color_slider = $("#color-slider")
      color_range_min_value = parseInt(getKeyByValue(numToColorMapping, state.colorRange[0]))
      color_range_max_value = parseInt(getKeyByValue(numToColorMapping, state.colorRange[1])) + 1
      color_slider.find("[data-range-type=\"min\"]").val(color_range_min_value).trigger("input")
      color_slider.find("[data-range-type=\"max\"]").val(color_range_max_value).trigger("input")
    }

    // Carat filter
    if (state.caratRange) {
      carat_slider = $("#carat-slider")
      carat_range_min_value = parseInt(state.caratRange[0] * 100);
      carat_range_max_value = parseInt(state.caratRange[1] * 100);
console.log(carat_range_min_value)
      carat_range_min_limit = parseInt(state.caratRangeLimit[0] * 100);
      carat_range_max_limit = parseInt(state.caratRangeLimit[1] * 100);

      carat_slider.find(`[data-range-type="min"]`).attr('min', carat_range_min_limit).attr('max', carat_range_max_limit);
      carat_slider.find(`[data-range-type="max"]`).attr('min', carat_range_min_limit).attr('max', carat_range_max_limit);

      carat_slider.find(`[data-range-type="min"]`).val(carat_range_min_value).trigger("input");
      carat_slider.find(`[data-range-type="max"]`).val(carat_range_max_value).trigger("input");
    }

    // Clarity filter
    if (state.clarityRange) {
      clarity_slider = $("#clarity-slider")
      clarity_range_min_value = parseInt(getKeyByValue(numToClarityMapping, state.clarityRange[0]))
      clarity_range_max_value = parseInt(getKeyByValue(numToClarityMapping, state.clarityRange[1])) + 1
      clarity_slider.find("[data-range-type=\"min\"]").val(clarity_range_min_value).trigger("input")
      clarity_slider.find("[data-range-type=\"max\"]").val(clarity_range_max_value).trigger("input")
    }

    // Price filter
    if (state.priceRange) {
      price_slider = $("#price-slider")
      price_range_min_value = parseInt(state.priceRange[0])
      price_range_max_value = parseInt(state.priceRange[1])
      price_slider.find("[data-range-type=\"min\"]").val(price_range_min_value).trigger("input")
      price_slider.find("[data-range-type=\"max\"]").val(price_range_max_value).trigger("input")
    }

    // Depth filter
    if (state.depthRange) {
      depth_slider = $("#depth-slider")
      depth_range_min_value = parseInt(state.depthRange[0])
      depth_range_max_value = parseInt(state.depthRange[1])
      depth_slider.find("[data-range-type=\"min\"]").val(depth_range_min_value).trigger("input")
      depth_slider.find("[data-range-type=\"max\"]").val(depth_range_max_value).trigger("input")
    }

    // Table filter
    if (state.tableRange) {
      table_slider = $("#table-slider")
      table_range_min_value = parseInt(state.tableRange[0])
      table_range_max_value = parseInt(state.tableRange[1])
      table_slider.find("[data-range-type=\"min\"]").val(table_range_min_value).trigger("input")
      table_slider.find("[data-range-type=\"max\"]").val(table_range_max_value).trigger("input")
    }

    // Polish filter
    if (state.polishRange) {
      polish_slider = $("#polish-slider")
      polish_range_min_value = parseInt(getKeyByValue(numToPolishMapping, state.polishRange[0]))
      polish_range_max_value = parseInt(getKeyByValue(numToPolishMapping, state.polishRange[1])) + 1
      polish_slider.find("[data-range-type=\"min\"]").val(polish_range_min_value).trigger("input")
      polish_slider.find("[data-range-type=\"max\"]").val(polish_range_max_value).trigger("input")
    }

    // Symmetry filter
    if (state.symmetryRange) {
      symmetry_slider = $("#symmetry-slider")
      symmetry_range_min_value = parseInt(getKeyByValue(numToSymmetryMapping, state.symmetryRange[0]))
      symmetry_range_max_value = parseInt(getKeyByValue(numToSymmetryMapping, state.symmetryRange[1])) + 1
      symmetry_slider.find("[data-range-type=\"min\"]").val(symmetry_range_min_value).trigger("input")
      symmetry_slider.find("[data-range-type=\"max\"]").val(symmetry_range_max_value).trigger("input")
    }

    // Lab filter
    if (state.labList && state.labList.length) {
      $("[data-lab-list-filter]").addClass("selected")
      $("[data-lab-list-filter]").attr("data-selected", state.labList.length)
      $("[name=\"lab\"]").prop("checked", false)
      state.labList.forEach(value => {
        value = value.replace("lab ", "")
        $(`[name="lab"][value="${value}"]`).prop("checked", true)
      })
    } else {
      $("[data-lab-list-filter]").removeClass("selected")
      $("[name=\"lab\"]").prop("checked", false)
    }

    // Fluorescence filter
    if (state.fluorescenceList && state.fluorescenceList.length) {
      $("[data-fluorescence-list-filter]").addClass("selected")
      $("[data-fluorescence-list-filter]").attr("data-selected", state.fluorescenceList.length)
      $("[name=\"fluorescence\"]").prop("checked", false)
      state.fluorescenceList.forEach(value => {
        value = value.replace("fluorescence ", "")
        $(`[name="fluorescence"][value="${value}"]`).prop("checked", true)
      })
    } else {
      $("[data-fluorescence-list-filter]").removeClass("selected")
      $("[name=\"fluorescence\"]").prop("checked", false)
    }

    setFiltersState(state)
  }

  function setFiltersState(state) {
    // Shape filter
    if (state.filtersState && state.filtersState.shape) {
      if (state.filtersState.shape.disabled) {
        $('[data-filter-name="shape"]').prop("disabled", true)
      } else {
        $('[data-filter-name="shape"]').prop("disabled", false)
      }

      if (state.filtersState.shape.disabled_values) {
        state.filtersState.shape.disabled_values.forEach(value => {
          $(`[data-filter-name="shape"][data-filter-value="${value}"]`).prop("disabled", true)
        })
      }
    } else {
      $('[data-filter-name="shape"]').prop("disabled", false)
    }

    // Cut filter
    cut_slider = $("#cut-slider")
    cut_range_first_marker_index = parseInt(getKeyByValue(numToCutMapping, state.cutRange[0]))
    cut_range_last_marker_index = parseInt(getKeyByValue(numToCutMapping, state.cutRange[1]))

    cut_slider_max_input = cut_slider.find("[data-range-type=\"min\"]")
    cut_slider_min_input = cut_slider.find("[data-range-type=\"max\"]")
    if (state.filtersState && state.filtersState.cutRange) {
      if (state.filtersState.cutRange.disabled) {
        cut_slider_max_input.prop("disabled", true)
        cut_slider_min_input.prop("disabled", true)
        $("[data-cut-range-marker]").addClass("disabled")
        cut_slider.addClass("disabled")
      } else {
        cut_slider_max_input.prop("disabled", false)
        cut_slider_min_input.prop("disabled", false)
        $("[data-cut-range-marker]").removeClass("disabled")
        cut_slider.removeClass("disabled")
      }

      for (var i = cut_range_first_marker_index; i <= cut_range_last_marker_index; i++) {
        marker = $("[data-cut-range-markers]").children()[i - 1]
        $(marker).removeClass("disabled")
      }
    } else {
      cut_slider_max_input.prop("disabled", false)
      cut_slider_min_input.prop("disabled", false)
      $("[data-cut-range-marker]").removeClass("disabled")
      cut_slider.removeClass("disabled")
    }

    // Color filter
    color_slider = $("#color-slider")
    color_range_first_marker_index = parseInt(getKeyByValue(numToColorMapping, state.colorRange[0]))
    color_range_last_marker_index = parseInt(getKeyByValue(numToColorMapping, state.colorRange[1]))

    color_slider_max_input = color_slider.find("[data-range-type=\"min\"]")
    color_slider_min_input = color_slider.find("[data-range-type=\"max\"]")
    color_slider_min_value = parseInt(color_slider_min_input.attr("min"))
    color_slider_max_value = parseInt(color_slider_max_input.attr("max"))

    if (state.filtersState && state.filtersState.colorRange) {
      if (state.filtersState.colorRange.disabled) {
        color_slider_max_input.prop("disabled", true)
        color_slider_min_input.prop("disabled", true)
        $("[data-color-range-marker]").addClass("disabled")
        color_slider.addClass("disabled")
      } else {
        color_slider_max_input.prop("disabled", false)
        color_slider_min_input.prop("disabled", false)
        $("[data-color-range-marker]").removeClass("disabled")
        color_slider.removeClass("disabled")
      }

//     for (var i = color_slider_min_value - 1; i <= color_slider_max_value; i++) {
//       marker = $('[data-color-range-markers]').children()[i - 1];
//       if (i >= color_range_first_marker_index && i <= color_range_last_marker_index) {
//         $(marker).removeClass('disabled');
//       } else {
//         $(marker).addClass('disabled');
//       }
//     }
      color_slider_min_input.attr("data-max-value", color_range_last_marker_index + 1).attr("data-min-value", color_range_first_marker_index)

      if (color_slider_min_input.val() < color_range_first_marker_index) {
        color_slider_min_input.val(color_range_first_marker_index)
      }

      color_slider_max_input.attr("data-max-value", color_range_last_marker_index + 1).attr("data-min-value", color_range_first_marker_index)

      if (color_slider_max_input.val() > color_range_last_marker_index + 1) {
        color_slider_max_input.val(color_range_last_marker_index + 1)
      }
    } else {
      $("[data-color-range-marker]").removeClass("disabled")
      color_slider.removeClass("disabled")
      color_slider_min_input.prop("disabled", false).attr("data-max-value", color_slider_max_value).attr("data-min-value", color_slider_min_value)
      color_slider_max_input.prop("disabled", false).attr("data-max-value", color_slider_max_value).attr("data-min-value", color_slider_min_value)
    }

    // Clarity filter
    clarity_slider = $("#clarity-slider")
    clarity_range_first_marker_index = parseInt(getKeyByValue(numToClarityMapping, state.clarityRange[0]))
    clarity_range_last_marker_index = parseInt(getKeyByValue(numToClarityMapping, state.clarityRange[1]))

    clarity_slider_max_input = clarity_slider.find("[data-range-type=\"min\"]")
    clarity_slider_min_input = clarity_slider.find("[data-range-type=\"max\"]")
    if (state.filtersState && state.filtersState.clarityRange) {
      if (state.filtersState.clarityRange.disabled) {
        clarity_slider_max_input.prop("disabled", true)
        clarity_slider_min_input.prop("disabled", true)
        $("[data-clarity-range-marker]").addClass("disabled")
        clarity_slider.addClass("disabled")
      } else {
        clarity_slider_max_input.prop("disabled", false)
        clarity_slider_min_input.prop("disabled", false)
        $("[data-clarity-range-marker]").removeClass("disabled")
        clarity_slider.removeClass("disabled")
      }

      for (var i = clarity_range_first_marker_index; i <= clarity_range_last_marker_index; i++) {
        marker = $("[data-clarity-range-markers]").children()[i - 1]
        $(marker).removeClass("disabled")
      }
    } else {
      clarity_slider_max_input.prop("disabled", false)
      clarity_slider_min_input.prop("disabled", false)
      $("[data-clarity-range-marker]").removeClass("disabled")
      clarity_slider.removeClass("disabled")
    }

    // Depth filter
    depth_slider = $("#depth-slider")
    depth_slider_max_input = depth_slider.find("[data-range-type=\"min\"]")
    depth_slider_min_input = depth_slider.find("[data-range-type=\"max\"]")
    if (state.filtersState && state.filtersState.depthRange) {
      if (state.filtersState.depthRange.disabled) {
        depth_slider_max_input.prop("disabled", true)
        depth_slider_min_input.prop("disabled", true)
        depth_slider.addClass("disabled")
      } else {
        depth_slider_max_input.prop("disabled", false)
        depth_slider_min_input.prop("disabled", false)
        $("[data-depth-range-marker]").removeClass("disabled")
        depth_slider.removeClass("disabled")
      }
    } else {
      depth_slider_max_input.prop("disabled", false)
      depth_slider_min_input.prop("disabled", false)
      depth_slider.removeClass("disabled")
    }

    // Table filter
    table_slider = $("#table-slider")
    table_slider_max_input = table_slider.find("[data-range-type=\"min\"]")
    table_slider_min_input = table_slider.find("[data-range-type=\"max\"]")
    if (state.filtersState && state.filtersState.tableRange) {
      if (state.filtersState.tableRange.disabled) {
        table_slider_max_input.prop("disabled", true)
        table_slider_min_input.prop("disabled", true)
        table_slider.addClass("disabled")
      } else {
        table_slider_max_input.prop("disabled", false)
        table_slider_min_input.prop("disabled", false)
        $("[data-table-range-marker]").removeClass("disabled")
        table_slider.removeClass("disabled")
      }
    } else {
      table_slider_max_input.prop("disabled", false)
      table_slider_min_input.prop("disabled", false)
      table_slider.removeClass("disabled")
    }

    // Polish filter
    polish_slider = $("#polish-slider")
    polish_slider_max_input = polish_slider.find("[data-range-type=\"min\"]")
    polish_slider_min_input = polish_slider.find("[data-range-type=\"max\"]")
    if (state.filtersState && state.filtersState.polishRange) {
      if (state.filtersState.polishRange.disabled) {
        polish_slider_max_input.prop("disabled", true)
        polish_slider_min_input.prop("disabled", true)
        polish_slider.addClass("disabled")
      } else {
        polish_slider_max_input.prop("disabled", false)
        polish_slider_min_input.prop("disabled", false)
        $("[data-polish-range-marker]").removeClass("disabled")
        polish_slider.removeClass("disabled")
      }
    } else {
      polish_slider_max_input.prop("disabled", false)
      polish_slider_min_input.prop("disabled", false)
      polish_slider.removeClass("disabled")
    }

    // Symmetry filter
    symmetry_slider = $("#symmetry-slider")
    symmetry_slider_max_input = symmetry_slider.find("[data-range-type=\"min\"]")
    symmetry_slider_min_input = symmetry_slider.find("[data-range-type=\"max\"]")
    if (state.filtersState && state.filtersState.symmetryRange) {
      if (state.filtersState.symmetryRange.disabled) {
        symmetry_slider_max_input.prop("disabled", true)
        symmetry_slider_min_input.prop("disabled", true)
        symmetry_slider.addClass("disabled")
      } else {
        symmetry_slider_max_input.prop("disabled", false)
        symmetry_slider_min_input.prop("disabled", false)
        $("[data-symmetry-range-marker]").removeClass("disabled")
        symmetry_slider.removeClass("disabled")
      }
    } else {
      symmetry_slider_max_input.prop("disabled", false)
      symmetry_slider_min_input.prop("disabled", false)
      symmetry_slider.removeClass("disabled")
    }

    // Lab filter
    lab_list_filter = $("[data-lab-list-filter]")
    if (state.filtersState && state.filtersState.labList) {
      if (state.filtersState.labList.disabled) {
        lab_list_filter.addClass("disabled")
      } else {
        lab_list_filter.removeClass("disabled")
      }
    } else {
      lab_list_filter.removeClass("disabled")
    }

    // Fluorescence filter
    fluorescence_list_filter = $("[data-fluorescence-list-filter]")
    if (state.filtersState && state.filtersState.fluorescenceList) {
      if (state.filtersState.fluorescenceList.disabled) {
        fluorescence_list_filter.addClass("disabled")
      } else {
        fluorescence_list_filter.removeClass("disabled")
      }
    } else {
      fluorescence_list_filter.removeClass("disabled")
    }
  }


  $("#price-min, #price-max").on("change", function(e) {
    value = $(this).val()
    range_type = $(this).data("change-range")
    $("#price-slider").find(`[data-range-type="${range_type}"]`).val(value).trigger("input").trigger("change")
  })

  $("#carat-min, #carat-max").on("change", function(e) {
    value = $(this).val()
    range_type = $(this).data("change-range")
    $("#carat-slider").find(`[data-range-type="${range_type}"]`).val(value * 100).trigger("input").trigger("change")
  })


  // Filters update
  $(document).on('click', '[data-toggle-filters-modal]', function(e){
    e.preventDefault();
    $('[data-filters-modal]').toggleClass('opened');
  });

  $(document).on('click', '[data-sorting-option]', function(e) {
    value = $(this).data('value');
    display_value = $(this).data('display-value');
    $('[data-current-sorting-value]').html(display_value);
    $('[data-sorting-option]').removeClass('selected');
    $(`[data-sorting-option][data-value="${value}"]`).addClass('selected');
    filterSort = value;

    parent_collapsible = $(this).parents('[data-collapsible-container]');
    collapsible_toggle = parent_collapsible.find('[data-toggle-collapsible]');
    if(collapsible_toggle.hasClass('opened')) {
      collapsible_toggle.click();
    }

    refreshStonesList();
  });


  $("[data-reset-filters]").click(() => {
    resetStonesFilters()
    setFiltersInputsValues(centerStonesFilterState[selectedStoneType])
    refreshStonesList()
  })


  $(document).on('click', '[data-filter-name]', function(e) {
    e.preventDefault();
    var filter_key = $(this).data('filter-name');
    var filter_value = $(this).data('filter-value');
    var filter_display_value = $(this).data('filter-display-value');
    if (typeof $(this).attr('data-toggleable') !== typeof undefined && $(this).attr('data-toggleable') !== false) {
      if ($(this).hasClass('selected')) {
        filter_value = undefined;
        filter_display_value = '';
        $(`[data-filter-name="${filter_key}"]`).removeClass('selected');
      } else {
        $(`[data-filter-name="${filter_key}"]`).removeClass('selected');
        $(`[data-filter-name="${filter_key}"][data-filter-value="${filter_value}"]`).addClass('selected');
      }
    } else {
      $(`[data-filter-name="${filter_key}"]`).removeClass('selected');
      $(`[data-filter-name="${filter_key}"][data-filter-value="${filter_value}"]`).addClass('selected');
    }
    $(`[data-filter-current-value][data-filter-key="${filter_key}"]`).html(filter_display_value);
    centerStonesFilterState[selectedStoneType][filter_key] = filter_value;
    refreshStonesList();
  });

  $(document).on('click', '[data-scrollable-item-change]', function(e) {
    e.preventDefault();
    var currently_shown_item = parseInt($('[data-scrollable-items-container]').attr('data-currently-shown-item'));
    var total_scrollable_items = parseInt($('[data-scrollable-items-container]').attr('data-total-scrollable-items'));
    var change = parseInt($(this).attr('data-scrollable-item-change'));
    var new_shown_item_index = currently_shown_item + change;
    if(new_shown_item_index > 0 && new_shown_item_index <= total_scrollable_items) {
      $('[data-scrollable-items-container]').attr('data-currently-shown-item', new_shown_item_index).css('--currently_shown_item', new_shown_item_index);

      if(new_shown_item_index == total_scrollable_items) {
        $('[data-scrollable-item-button-next]').prop('disabled', true);
      } else {
        $('[data-scrollable-item-button-next]').prop('disabled', false);
      }

      if(new_shown_item_index == 1) {
        $('[data-scrollable-item-button-prev]').prop('disabled', true);
      } else {
        $('[data-scrollable-item-button-prev]').prop('disabled', false);
      }

      $(`[data-scrollable-item-dot="${new_shown_item_index}"]`).addClass('active').siblings().removeClass('active');
    }
  });

  $(document).on('click', '[data-scrollable-item-dot]', function(e) {
    e.preventDefault();
    var currently_shown_item = parseInt($('[data-scrollable-items-container]').attr('data-currently-shown-item'));
    var total_scrollable_items = parseInt($('[data-scrollable-items-container]').attr('data-total-scrollable-items'));
    var new_shown_item_index = parseInt($(this).data('scrollable-item-dot'));
    if (new_shown_item_index != currently_shown_item) {
      $(this).addClass('active').siblings().removeClass('active');

      $('[data-scrollable-items-container]').attr('data-currently-shown-item', new_shown_item_index).css('--currently_shown_item', new_shown_item_index);

      if(new_shown_item_index == total_scrollable_items) {
        $('[data-scrollable-item-button-next]').prop('disabled', true);
      } else {
        $('[data-scrollable-item-button-next]').prop('disabled', false);
      }

      if(new_shown_item_index == 1) {
        $('[data-scrollable-item-button-prev]').prop('disabled', true);
      } else {
        $('[data-scrollable-item-button-prev]').prop('disabled', false);
      }
    }
  });

  $(document).on('click', '[data-diamond-wizard-filter-shape]', function(){
    diamondWizardFilters["shape"] = $(this).data('diamond-wizard-filter-value');
  });

  $(document).on('click', '[data-capture-diamond-wizard-price]', function(){
    value = parseInt($('[data-diamond-wizard-price-slider]').val());
    adjustment_value = value * 0.1;
    diamondWizardFilters["priceRange"] = [value - adjustment_value, value + adjustment_value];
  });

  $(document).on('click', '[data-diamond-wizard-filter-group]', function(){
    group = $(this).data('diamond-wizard-filter-value');
    selected_filter_group = diamondWizardPresets[group];
    for (var [key, value] of Object.entries(selected_filter_group)) {
      diamondWizardFilters[key] = value;
    }
  });

  $(document).on('click', '[data-diamond-wizard-go-to-final-step]', function() {
    filterQuery = generateDiamondWizardFilterQuery();
    urlFinal = `https://services.mybcapps.com/bc-sf-filter/filter?pf_st_stock_status[]=true&sort=${diamondWizardSort}&shop=kev-jewellery.myshopify.com&limit=4${filterQuery}`
    $('[data-diamond-wizard-placeholders]').show();
    $('[data-diamond-wizard-results]').hide();
    $('[data-diamond-wizard-results]').empty();
    fetch(urlFinal, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    }).then((res) => {
      res.text().then((resText) => {
        resObj = JSON.parse(resText);
        console.log(resObj);
        $('[data-diamond-wizard-placeholders]').hide();
        $('[data-diamond-wizard-results]').show();
        resObj.products.forEach((product) => {
          createDiamondWizardCenterStoneProductElement(product);
        })
      })
    })
  });

  function generateDiamondWizardFilterQuery() {
    retQuery = ''; 
    retQuery += `&product_type[]=${selectedStoneType === 'labDiamond' ? centerStonesFilterState['labDiamond'].type : centerStonesFilterState['diamond'].type}`;
    retQuery += `&pf_t_shape[]=shape ${diamondWizardFilters.shape}`

    priceFilterQuery = generateNumbersRangeQuery("pf_p_price", diamondWizardFilters.priceRange[0], diamondWizardFilters.priceRange[1])
    retQuery += priceFilterQuery

    cutsToFilter = getAllInTagsRange(diamondWizardFilters.cutRange, cutRangeList)
    cutsFilterQuery = generateTagsRangeQuery("pf_t_cut", cutsToFilter)
    retQuery += cutsFilterQuery
    if (retQuery.includes("&pf_t_cut[]=cut Excellent")) retQuery += "&pf_t_cut[]=cut Ideal"

    colorsToFilter = getAllInTagsRange(diamondWizardFilters.colorRange, colorRangeList)
    colorsFilterQuery = generateTagsRangeQuery("pf_t_color", colorsToFilter)
    retQuery += colorsFilterQuery

    clarityToFilter = getAllInTagsRange(diamondWizardFilters.clarityRange, clarityRangeList)
    clarityFilterQuery = generateTagsRangeQuery("pf_t_clarity", clarityToFilter)
    retQuery += clarityFilterQuery

    return retQuery
  }

  function createDiamondWizardCenterStoneProductElement(product) {
    productsContainer = $('[data-diamond-wizard-results]');
    stoneInfo = {}
    splitHandle = product.handle.split("-")
    stone_id = splitHandle[splitHandle.length - 1]

    for (let k = 0; k < product.tags.length; k++) {
      const splitTag = product.tags[k].split(/ (.+)/)
      stoneInfo[splitTag[0]] = splitTag[1] === "true" ? true : splitTag[1] === "false" ? false : splitTag[1]
    }

    hasImage = !!product.images[1]

    html = ""

    itemThumbClass = "item-thumb pre-loader"

    imgSrc = hasImage ? product.images[1] : shapeToImage[stoneInfo.shape]

    certObj = product.metafields.find(meta => meta.key === "cert-link")

    makeInfo = (property, value) => `<div class="center-stone-item-info-element"><span class="center-stone-item-info-element-property">${property.capitalize()}</span><span class="center-stone-item-info-element-value">${value}</span></div>`

    makeCert = (certObjOld, lab) => {
      certObjNew = {
        certPageLink: certObjOld.value,
        certId: "",
        certLink: "",
        img: ""
      }

      certObjNew.certId = certObjNew.certPageLink.split("=").reverse()[0]

      if (lab.toLowerCase() === "igi") {
        certObjNew.img = "https://www.igi.org/assets/images/logo-for-title.svg"
        certObjNew.certLink = "https://www.igi.org/viewpdf.php?r=" + certObjNew.certId
      } else if (lab.toLowerCase() === "gia") {
        certObjNew.img = "https://cdn.shopify.com/s/files/1/0039/6994/1568/t/116/assets/kzr-icon-gia-crt.svg?v=1638199804"
        certObjNew.certLink = certObjNew.certPageLink
      }

      return certObjNew
    }

    cert = !certObj || !stoneInfo.lab ? null : makeCert(certObj, stoneInfo.lab)

    // For overlay add to the <a> tag `onclick="showCert(event, this)"`
    const certDiv = cert ? `<div><a class="center-stone-item-certificate-link" target="_blank" href="${cert.certLink}"><img width="82" height="82" src="${cert.img}" alt="${stoneInfo.lab.toUpperCase()} Certificate"><span>View Certificate</span></a></div>` : ""

    var compare_at_price = '';
    if (product.compare_at_price_min > product.price_min) {
      compare_at_price = `
        <div class="price price-compare">\$${Math.round(product.compare_at_price_min).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
      `;
    }

    var button_text = 'Complete Your Ring';
    if (configurationData?.configuration?.setting) {
      configurationType == 'Pendant' ? button_text = 'Complete Your Pendant' : button_text = 'Complete Your Ring'
    } else {
      configurationType == 'Pendant' ? button_text = 'Add Pendant' : button_text = 'Add Setting'
    }

    html = `
      <div class="center-stone-item card-shadow">
        <div class="center-stone-item-slide-wrap">
          <div class="center-stone-item-img-wrap diamWrap">
            <div>
              <img src="${imgSrc}" 
                class="diamImage"
                alt="${hasImage ? imageAltWithoutData(product.images_info[0].alt) : product.title}"
                ${hasImage ? imageAltDataAttributes(product.images_info[0].alt) : ''}>
            </div>
          </div>
          <div class="center-stone-item-info">
            <div>${["shape", "carat", "color", "clarity", "lab"].reduce((result, key) => result + makeInfo(key, stoneInfo[key]), "")}</div>
            <div class="price-wrap">
              ${compare_at_price}
              <div class="price price-final">\$${Math.round(product.price_min).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
            </div>
          </div>
        </div>
        <a href="${location.pathname + '/products/' + product.handle}" class="absolute inset-0 opacity-0"></a>
      </div>
    `

    productsContainer.append(html);
  }

  $(window).on('scroll', function(){
    if($('.cmsi-item-primary-button').length) {
      if($('.cmsi-item-primary-button:visible').length && isAnyPartOfElementInViewport($('.cmsi-item-primary-button:visible')[0])) {
        $('body').addClass('select-button-in-viewport');
      } else {
        $('body').removeClass('select-button-in-viewport');
      }
    } else {
      $('body').removeClass('select-button-in-viewport');
    }

    if(isAnyPartOfElementInViewport($('[data-toggle-filters-modal].static')[0])) {
      $('body').removeClass('static-toggle-filters-button-not-in-viewport');
    } else {
      $('body').addClass('static-toggle-filters-button-not-in-viewport');
    }
  });

  $(document).on('click', '[data-add-centerstone]', function(e) {
    addLoader(this);
    product_item = $(this).parents('[data-product-item]');
    product = JSON.parse(product_item.find('[data-product-json]').text());
    addCenterStone(product);
  });
}
